/* eslint-disable */
// Fonte da verdade do i18n: os valores pt são os textos originais do app.
export default {
    // comuns
    'common.close': 'Fechar X',

    // widgets de agendamento (ReserveForm / GridView / WidgetForm / WidgetSuccess)
    'widget.vacancies': '{n} vagas disponíveis!',
    'widget.vacanciesTooltip': 'Este o número de pessoas que ainda podem participar desse evento',
    'widget.event': 'Evento:',
    'widget.eventClosed': 'Fechado',
    'widget.scheduledBy': 'Agendado por:',
    'widget.contact': 'Contato:',
    'widget.choosePackage': 'Escolha seu pacote',
    'widget.available': 'disponível',
    'widget.noTickets': 'Nenhum tipo de ingresso cadastrado. Favor, entre em contato conosco para continuar.',
    'widget.continue': 'CONTINUAR',
    'widget.disagree': 'Alguma informação contida aqui você não está de acordo?',
    'widget.reportProblem': 'Informe um problema',
    'widget.easyCancellation': 'Cancelamento Fácil',
    'widget.dataSecurity': 'Segurança de dados',
    'widget.cancelRules': 'Regras de Cancelamento',
    'widget.chooseDate': 'Escolha a Data:',
    'widget.chooseHour': 'Escolha o Horário:',
    'widget.today': 'Hoje',
    'widget.select': 'SELECIONE',
    'widget.noDates': 'Infelizmente não há datas disponíveis para fazer a reserva online. Entre em contato conosco e saiba mais.',
    'widget.insertData': 'Insira seus Dados:',
    'widget.freeScheduling': 'Você não precisa pagar para fazer o agendamento',
    'widget.shareInvite': 'Convide seus amigos compartilhando este link com as informações sobre a reserva:',
    'widget.reserved': 'Seu horário foi reservado!',
    'widget.copy': 'Copiar',
    'widget.reserveHour': 'Reservar horário',
    'widget.unavailable': 'Indisponível',
    'widget.hourStillAvailable': 'Horário ainda disponível',
    'widget.reserve': 'Reservar',
    'widget.spots': 'vagas',

    // login / cadastro / recuperação de senha
    'auth.facebook': 'LOGAR COM FACEBOOK',
    'auth.or': 'ou',
    'auth.name': 'Nome',
    'auth.email': 'Email',
    'auth.phone': 'Telefone',
    'auth.password': 'Senha',
    'auth.signupButton': 'CADASTRE-SE',
    'auth.signinButton': 'ENTRAR',
    'auth.signin': 'Entrar',
    'auth.signup': 'Cadastre-se',
    'auth.forgot': 'Esqueci minha senha',
    'auth.send': 'Enviar',
    'auth.loggedIn': 'Logado com sucesso',
    'auth.facebookError': 'Falha ao tentar acessar via Facebook.',
    'auth.forgotSent': 'Foi enviado um email com a sua nova senha!',
    'validation.requiredField': '"{field}" não pode ficar em branco.',
    'validation.invalidField': '"{field}" inválido.',

    // moldura do wizard (components/Modal/Modal.js)
    'checkout.back': 'Voltar',
    'checkout.steps.info': 'Informações',
    'checkout.steps.payment': 'Pagamento',
    'checkout.steps.done': 'Conclusão',

    // passo Informações (Reserves)
    'checkout.info.title': 'Informações',
    'checkout.info.selectParticipant': 'Selecione um participante para inserir seus dados:',
    'checkout.info.fillParticipant': 'Preencha os dados do participante:',
    'checkout.info.participant': 'Participante {n}',
    'checkout.info.fullName': 'Nome completo*',
    'checkout.info.nameRequired': 'Nome é um campo obrigatório',
    'checkout.info.email': 'Email*',
    'checkout.info.emailInvalid': 'Email inválido',
    'checkout.info.cellPhone': 'Telefone Celular*',
    'checkout.info.observation': 'Observação',
    'checkout.info.observationHint': '(Ex: Atendimento especial, código promocional, etc.)',
    'checkout.info.privacyAgree': 'Concordo com a {link}',
    'checkout.info.privacyPolicy': 'Política de privacidade de dados',
    'checkout.continue': 'Continuar',
    'checkout.next': 'Próximo',

    // passo Pagamento (PaymentMethod / ConfirmPayment)
    'payment.title': 'Pagamento',
    'payment.choose': 'Escolha sua forma de pagamento:',
    'payment.discount.title': 'Desconto',
    'payment.discount.question': 'Possui um cupom de desconto? Aplique aqui:',
    'payment.discount.placeholder': 'Cupom de desconto',
    'payment.discount.apply': 'Aplicar',
    'payment.discount.remove': 'Remover',
    'payment.discount.added': 'Cupom adicionado com sucesso!',
    'payment.discount.removed': 'Cupom removido com sucesso!',
    'payment.discount.invalid': 'Cupom inválido!',
    'payment.confirmAndPay': 'CONFIRMAR E PAGAR',
    'payment.reserve': 'RESERVAR',
    'payment.redirectInfo': 'Ao confirmar, você será direcionado para a página segura do {gateway} para concluir o pagamento e depois voltará para cá.',
    'payment.creditCardBrazilOnly': 'O pagamento com cartão de crédito aceita apenas cartões emitidos no Brasil. Se o seu cartão for internacional, utilize o PayPal.',

    // telefone
    'phone.label': 'Telefone',
    'phone.intlHint': 'ex.: +55 41 99999 0000',
    'validation.phoneInvalid': 'Número inválido',
};
